<template>
    <div class="SearchCont">
        <!--searchCont头部-->
        <el-form class="leader-style-form leader-form-inline" :inline="true">
            <el-row :gutter="10">
                <el-col :span="6">
                    <el-form-item label="班组名称">
                        <el-input maxlength="50" v-model="searchName" autocomplete="off"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="18" style="text-align:right">
                    <el-button type="primary" @click="search" size="small">查询</el-button>
                    <el-button type="primary" @click="addNewOne('addForm')" size="small">增加</el-button>
                </el-col>
            </el-row>
        </el-form>
        <div class="table-wrap">
            <el-table :data="tableJson" border style="width: 100%;" class="leader-style-table">
                <el-table-column type="index" width="50" align="center" label="序号" property="num"></el-table-column>
                <el-table-column label="班组名称" property="group_name" align="center"></el-table-column>
                <el-table-column label="成员数量" property="user_count" align="center"></el-table-column>
                <el-table-column label="负责人" property="leader_user_name" align="center"></el-table-column>
                <el-table-column label="负责人电话" property="duty_person_phone" align="center"></el-table-column>
                <el-table-column label="应急电话" property="sos_phone" align="center"></el-table-column>
                <el-table-column label="主要责任" property="duty" align="center"></el-table-column>
                <el-table-column label="修改" width="180" align="center">
                    <template slot-scope="scope">
                        <el-button
                            @click="changeItemShow(scope.row)"
                            type="text"
                            class="button-modify"
                        >
                            <i class="iconfont iconeditor"></i>
                            <span class="inner-text">修改</span>
                        </el-button>
                        <el-button
                            @click="deleteItemShow(scope.row)"
                            type="text"
                            class="button-delete"
                        >
                            <i class="iconfont iconashbin"></i>
                            <span class="inner-text">删除</span>
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <Pagination
                class="leader-style-pagination"
                :paginationData="paginationData"
                @paginationDataNew="paginationDataNew"
                v-if="this.paginationData.totalNum"
            ></Pagination>
        </div>

        <!--新增dialog-->
        <el-dialog
            class="leader-dialog"
            title="新增"
            width="1000px"
            :visible.sync="addshow"
            :close-on-click-modal="false"
        >
            <el-form class="leader-style-form" :rules="formRules" :model="addForm" ref="addForm">
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="班组名称" :label-width="formLabelWidth" prop="nameAdd">
                            <el-input maxlength="30" autocomplete="off" v-model="addForm.nameAdd"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item
                            label="班组成员"
                            :label-width="formLabelWidth"
                            prop="membersValueAdd"
                        >
                            <el-select
                                v-model="addForm.membersValueAdd"
                                multiple
                                style="width: 100%"
                            >
                                <el-option
                                    v-for="item in membersJson"
                                    :key="item.user_id"
                                    :label="item.user_name"
                                    :value="item.user_id"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="负责人" :label-width="formLabelWidth" prop="headValueAdd">
                            <el-select v-model="addForm.headValueAdd" style="width: 100%">
                                <el-option
                                    v-for="item in headJson"
                                    :key="item.user_id"
                                    :label="item.user_name"
                                    :value="item.user_id"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item
                            label="负责人电话"
                            :label-width="formLabelWidth"
                            prop="headPhoneAdd"
                        >
                            <el-input
                                maxlength="20"
                                autocomplete="off"
                                v-model="addForm.headPhoneAdd"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="应急电话" :label-width="formLabelWidth" prop="phoneAdd">
                            <el-input maxlength="20" autocomplete="off" v-model="addForm.phoneAdd"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item
                            label="主要责任"
                            :label-width="formLabelWidth"
                            style="width: 100%;"
                            prop="mainAdd"
                        >
                            <el-input
                                type="textarea"
                                v-model="addForm.mainAdd"
                                resize="none"
                                rows="3"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="addshow = false" class="leader-common-button">取消</el-button>
                <el-button
                    class="leader-common-button"
                    @click="addcommit('addForm')"
                    :loading="this.$store.state.btnType"
                >保存</el-button>
            </div>
        </el-dialog>

        <!--修改dialog-->
        <el-dialog
            class="leader-dialog"
            title="修改"
            :visible.sync="editshow"
            width="1000px"
            :close-on-click-modal="false"
        >
            <el-form class="leader-style-form" :rules="formRules" :model="editForm" ref="editForm">
                <div class="childForm_mr10 childForm_w33 h70 space_around">
                    <el-form-item label="班组名称" :label-width="formLabelWidth" prop="nameAdd">
                        <el-input maxlength="30" autocomplete="off" v-model="editForm.nameAdd"></el-input>
                    </el-form-item>
                    <el-form-item
                        label="班组成员"
                        :label-width="formLabelWidth"
                        prop="membersValueAdd"
                        style="width: 66%;"
                    >
                        <el-select v-model="editForm.membersValueAdd" multiple>
                            <el-option
                                v-for="item in membersJson"
                                :key="item.user_id"
                                :label="item.user_name"
                                :value="item.user_id"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                </div>

                <div class="childForm_mr10 childForm_w33 space_around h70">
                    <el-form-item label="负责人" :label-width="formLabelWidth" prop="headValueAdd">
                        <el-select v-model="editForm.headValueAdd">
                            <el-option
                                v-for="item in headJson"
                                :key="item.user_id"
                                :label="item.user_name"
                                :value="item.user_id"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="负责人电话" :label-width="formLabelWidth" prop="headPhoneAdd">
                        <el-input maxlength="20" autocomplete="off" v-model="editForm.headPhoneAdd"></el-input>
                    </el-form-item>
                    <el-form-item label="应急电话" :label-width="formLabelWidth" prop="phoneAdd">
                        <el-input maxlength="20" autocomplete="off" v-model="editForm.phoneAdd"></el-input>
                    </el-form-item>
                </div>
                <div class="childForm_mr10 childForm_w33 space_around">
                    <el-form-item
                        label="主要责任"
                        :label-width="formLabelWidth"
                        style="width: 100%;"
                        prop="mainAdd"
                    >
                        <el-input type="textarea" v-model="editForm.mainAdd" resize="none" rows="5"></el-input>
                    </el-form-item>
                </div>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="editshow = false" class="leader-common-button">取消</el-button>
                <el-button
                    class="leader-common-button"
                    @click="editcommit('editForm')"
                    :loading="this.$store.state.btnType"
                >保存</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import Pagination from "@/comon/components/pagination.vue";
export default {
    name: "Main",
    components: {
        Pagination,
    },
    data() {
        return {
            tableJson: [],
            searchName: "",
            formLabelWidth: "120px",
            addForm: {
                nameAdd: "",
                membersValueAdd: [],
                headValueAdd: "",
                headPhoneAdd: "",
                phoneAdd: "",
                mainAdd: "",
            },
            editForm: {
                nameAdd: "",
                membersValueAdd: [],
                headValueAdd: "",
                headPhoneAdd: "",
                phoneAdd: "",
                mainAdd: "",
            },
            headJson: [],
            membersJson: [],
            edit_group_id: "",
            addshow: false,
            editshow: false,
            formRules: {
                nameAdd: [
                    {
                        required: true,
                        message: "请输入班组名称",
                        trigger: "change",
                    },
                ],
                membersValueAdd: [
                    {
                        required: true,
                        message: "请选择班组成员",
                        trigger: "change",
                    },
                ],
                headValueAdd: [
                    {
                        required: true,
                        message: "请选择负责人",
                        trigger: "change",
                    },
                ],
                headPhoneAdd: [
                    {
                        required: true,
                        message: "请输入负责人电话",
                        trigger: "change",
                    },
                ],
                phoneAdd: [
                    {
                        required: true,
                        message: "请输入应急电话",
                        trigger: "change",
                    },
                ],
                mainAdd: [
                    {
                        required: true,
                        message: "请填写主要责任",
                        trigger: "change",
                    },
                ],
            },
            // 分页器数据
            paginationData: {
                pageNum: 1,
                pageSize: 10,
                totalNum: "",
            },
        };
    },
    methods: {
        addNewOne(formName) {
            this.addshow = true;
            this.addForm.nameAdd = "";
            this.addForm.membersValueAdd = [];
            this.addForm.headValueAdd = "";
            this.addForm.headPhoneAdd = "";
            this.addForm.phoneAdd = "";
            this.addForm.mainAdd = "";
            this.$refs[formName].resetFields();
        },
        addcommit(formName) {
            this.$store.commit("btnTypeTrue");
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.$axios
                        .post(
                            "/operation/group/saveGroup",
                            {
                                group_id: "",
                                group_name: this.addForm.nameAdd,
                                user_ids: this.addForm.membersValueAdd,
                                leader_user_id: this.addForm.headValueAdd,
                                duty_person_phone: this.addForm.headPhoneAdd,
                                sos_phone: this.addForm.phoneAdd,
                                duty: this.addForm.mainAdd,
                            },
                            {
                                headers: {
                                    token: window.localStorage.getItem("token"),
                                    "Content-Type": "application/json"
                                },
                            }
                        )
                        .then((res) => {
                            if (res.error_code == 0) {
                                this.addshow = false;
                                this.getTable();
                                // this.common.setToken(res.token);

                                this.$store.commit(
                                    "btnTypeFalse",
                                    this.addshow
                                );
                            } else if (res.error_code == -1) {
                                this.$router.push({
                                    path: "/login",
                                });

                                this.$store.commit(
                                    "btnTypeFalse",
                                    this.addshow
                                );
                            } else {

                                this.$store.commit(
                                    "btnTypeFalse",
                                    this.addshow
                                );
                            }
                        });
                } else {
                    return false;
                }
            });
        },
        getMembers() {
            this.$axios
                .post(
                    "/operation/group/getGroupUsers",
                    {},
                    {
                        headers: {
                            token: window.localStorage.getItem("token"),
                            "Content-Type": "application/json"
                        },
                    }
                )
                .then((res) => {
                    if (res.error_code == 0) {
                        this.headJson = res.bus_json;
                        this.membersJson = res.bus_json;
                        // this.common.setToken(res.token);
                    } else if (res.error_code == -1) {
                        this.$router.push({
                            path: "/login",
                        });

                    } else {

                    }
                });
        },
        search() {
            this.getTable(this.searchName);
        },
        getTable(searchName) {
            this.$axios
                .post(
                    "/operation/group/getGroupList",
                    {
                        pageNum: this.paginationData.pageNum,
                        pageSize: this.paginationData.pageSize,
                        group_name: searchName ? searchName : "",
                    },
                    {
                        headers: {
                            token: window.localStorage.getItem("token"),
                            "Content-Type": "application/json"
                        },
                    }
                )
                .then((res) => {
                    if (res.error_code == 0) {
                        this.tableJson = res.bus_json.items;
                        // this.common.setToken(res.token);
                        this.paginationData.totalNum =
                            res.bus_json.totalNum;
                        this.paginationData.pageNum = res.bus_json.pageNum;
                        this.paginationData.pageSize =
                            res.bus_json.pageSize;
                    } else if (res.error_code == -1) {
                        this.$router.push({
                            path: "/login",
                        });

                    }
                });
        },
        changeItemShow(sth) {
            this.edit_group_id = sth.group_id;
            this.$axios
                .post(
                    "/operation/group/getGroupById",
                    {
                        group_id: sth.group_id,
                    },
                    {
                        headers: {
                            token: window.localStorage.getItem("token"),
                            "Content-Type": "application/json"
                        },
                    }
                )
                .then((res) => {
                    if (res.error_code == 0) {
                        this.editForm.nameAdd = res.bus_json.group_name;
                        this.editForm.membersValueAdd =
                            res.bus_json.user_ids;
                        this.editForm.headValueAdd =
                            res.bus_json.leader_user_id;
                        this.editForm.headPhoneAdd =
                            res.bus_json.duty_person_phone;
                        this.editForm.phoneAdd = res.bus_json.sos_phone;
                        this.editForm.mainAdd = res.bus_json.duty;
                        this.editshow = true;
                    } else if (res.error_code == -1) {
                        this.$router.push({
                            path: "/login",
                        });

                    }
                });
        },
        deleteItemShow(sth) {
            this.$confirm("确认删除该数据?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                this.$axios
                    .post(
                        "operation/group/delGroup",
                        {
                            group_id: sth.group_id,
                        },
                        {
                            headers: {
                                token: window.localStorage.getItem("token"),
                                "Content-Type": "application/json"
                            },
                        }
                    )
                    .then((res) => {
                        if (res.error_code == 0) {
                            // this.common.setToken(res.token);
                            this.$message({
                                type: "success",
                                message: res.error_msg,
                            });
                            this.getTable();
                        } else {
                            this.$message({
                                type: "info",
                                message: res.error_msg,
                            });
                        }
                    });
            });
        },
        paginationDataNew(sth) {
            this.paginationData = sth;
            this.getTable();
        },
        editcommit(formName) {
            this.$store.commit("btnTypeTrue");
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.$axios
                        .post(
                            "/operation/group/saveGroup",
                            {
                                group_id: this.edit_group_id,
                                group_name: this.editForm.nameAdd,
                                user_ids: this.editForm.membersValueAdd,
                                leader_user_id: this.editForm.headValueAdd,
                                duty_person_phone: this.editForm.headPhoneAdd,
                                sos_phone: this.editForm.phoneAdd,
                                duty: this.editForm.mainAdd,
                            },
                            {
                                headers: {
                                    token: window.localStorage.getItem("token"),
                                    "Content-Type": "application/json"
                                },
                            }
                        )
                        .then((res) => {
                            if (res.error_code == 0) {
                                this.editshow = false;
                                this.getTable();
                                // this.common.setToken(res.token);

                                this.$store.commit(
                                    "btnTypeFalse",
                                    this.editshow
                                );
                            } else if (res.error_code == -1) {
                                this.$router.push({
                                    path: "/login",
                                });

                                this.$store.commit(
                                    "btnTypeFalse",
                                    this.editshow
                                );
                            } else {

                                this.$store.commit(
                                    "btnTypeFalse",
                                    this.editshow
                                );
                            }
                        });
                } else {
                    return false;
                }
            });
        },
    },
    mounted() {
        this.getTable();
        this.getMembers();
    },
};
</script>

<style scoped>
.SearchCont {
    /* background: #fff; */
}
</style>
